<template>
    <div>
        <div class="form-group d-flex align-items-center">
            <h1 class="col-xs-11">
                News
                <router-link
                    :to="{name: 'create-news'}"
                    tag="button"
                    type="button"
                    class="btn btn-sm btn-primary mr-1"
                >Create</router-link>
            </h1>
            <form class="form-inline d-flex ml-auto col-xs-11">
                <input
                    autofocus
                    class="form-control form-control-sm"
                    type="text"
                    placeholder="Search by name"
                    v-model="news_title"
                />
                <button class="btn btn-primary btn-sm ml-1" type="button" @click="news_title = null">Clear</button>
            </form>
        </div>

        <div class="alert alert-danger" v-if="error">
            <p class="mb-0">{{ error }}</p>
        </div>

        <datatable
            class="mt-4"
            :cols="columns"
            :rows="news.filter(c => news_title ? c.title.toLowerCase().includes(news_title.toLowerCase()) : true)"
        />
    </div>
</template>

<script>
import store from "../../../store";
import { mapState } from "vuex";
import DataTable from "../../DataTable";
import { createDatatableButtons, getError } from "../../../helpers";

export default {
    components: {
        datatable: DataTable
    },

    data() {
        return {
            news_title: null,
            name: null,
            error: null,

            columns: [
                {headerName: 'ID',          field: 'id',             sortable: true, filter: true, resizable: true, minWidth: 50,  maxWidth: 75 },
                {headerName: 'Title',       field: 'title',          sortable: true, filter: true, resizable: true, minWidth: 150,              },
                {
                    headerName: 'Actions',
                    field: 'id',
                    minWidth: 175,
                    maxWidth: 175,

                    cellRenderer: params => {
                        const buttons = [
                            {
                                name: 'View',
                                type: 'secondary',
                                handler: () => {
                                    this.$router.push({name: 'view-news', params: {
                                        id: params.data.id,
                                    }});
                                },
                            },
                        ];

                        buttons.push({
                            name: 'Edit',
                            type: 'secondary',
                            handler: () => {
                                this.$router.push({name: 'edit-news', params: {
                                    id: params.data.id,
                                }});
                            },
                        });

                        const isDeleted = !!params.data.deleted_at;
                        buttons.push({
                            name: isDeleted ? 'Restore' : 'Archive',
                            type: isDeleted ? 'info' : 'danger',
                            handler: () => {
                                if (confirm(`Are you sure you want to ${isDeleted ? 'restore' : 'archive'} this news entry?`)) {
                                    this.error = null;

                                    this.$store.dispatch(`news/${isDeleted ? 'restore' : 'delete'}`, {
                                        newsId: params.data.id,
                                    }).catch(e => {
                                        this.error = getError(e);
                                    });
                                }
                            },
                        });
                        return createDatatableButtons(buttons);
                    }
                }
            ],
        };
    },

    computed: {
        ...mapState({
            news: state =>
                state.news.news.map(a => ({ ...a })),
		}),
	},
	
    async beforeRouteEnter(to, from, next) {
        await store.dispatch('news/fetchAll');
        next();
    },

    meta: {
        title: "News",

        meta: [{ property: "og:title", content: "News / Al-Shayah" }]
    }
};
</script>

<style scoped>
</style>
